// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"70":"62fd96fa","317":"6974719c","453":"1e74286a"}[chunkId] + ".chunk.js");